export enum OmsActionType {
  ACCEPT_OMS = 'accept/oms',
}
